/**
 * Promo code apply/remove for the cart drawer and the /cart page.
 *
 * Uses the Cart AJAX API's POST /cart/update.js endpoint with a "discount"
 * parameter (single code, or empty string to clear). This is a JS-driven
 * feature by necessity — Shopify does not offer a plain-HTML/no-JS way to
 * apply a discount code from a freeform text field pre-checkout, so the
 * markup includes a <noscript> fallback pointing shoppers to the discount
 * field Shopify's hosted checkout already shows automatically. Everything
 * else on the cart page (quantity updates, remove, checkout) still works
 * without JavaScript — this is the one deliberate, flagged exception.
 */
(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function hasDiscount(cart) {
    return !!(cart && cart.total_discount && cart.total_discount > 0);
  }

  function updateDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (res) {
      return res.json();
    });
  }

  function setMessage(container, text, state) {
    var message = container.querySelector('[data-discount-message]');
    if (!message) return;
    message.textContent = text || '';
    if (state) {
      message.setAttribute('data-state', state);
    } else {
      message.removeAttribute('data-state');
    }
  }

  function handleApply(container) {
    var input = container.querySelector('[data-discount-input]');
    var button = container.querySelector('[data-discount-submit]');
    var code = input ? (input.value || '').trim() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }

    var originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Applying…';
    }
    setMessage(container, '', null);

    updateDiscount(code)
      .then(function (cart) {
        var ok = hasDiscount(cart);
        setMessage(
          container,
          ok ? 'Promo code applied.' : "That code couldn't be applied — double check it and try again.",
          ok ? 'success' : 'error'
        );
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { openDrawer: false } }));

        if (ok) {
          var reloadScope = container.closest('[data-discount-reload]');
          if (reloadScope) {
            window.setTimeout(function () {
              window.location.reload();
            }, 500);
          }
        }
      })
      .catch(function () {
        setMessage(container, 'Something went wrong. Please try again.', 'error');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      });
  }

  function handleRemove(button) {
    button.disabled = true;

    updateDiscount('')
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { openDrawer: false } }));
        var reloadScope = button.closest('[data-discount-reload]');
        if (reloadScope) {
          window.setTimeout(function () {
            window.location.reload();
          }, 300);
        }
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-discount-submit]');
    if (applyBtn) {
      e.preventDefault();
      handleApply(applyBtn.closest('[data-discount-form]'));
      return;
    }
    var removeBtn = e.target.closest('[data-discount-remove]');
    if (removeBtn) {
      e.preventDefault();
      handleRemove(removeBtn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-discount-input]');
    if (!input) return;
    e.preventDefault();
    handleApply(input.closest('[data-discount-form]'));
  });
})();
